import axios, { baseUrl } from './axios';

export default {
  loadFeatureList: async (options = {}) => {
    const result = await axios.get(`${baseUrl}/account/features`);
    return result.data;
  },
};
